import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private dialog: MatDialog,
    private ngZone: NgZone
  ) { }

  handleError(erroRecebido: any): void {
    // Promise rejeitada sem catch (ex.: await ...toPromise()) chega aqui embrulhada pelo zone.js
    // num Error('Uncaught (in promise): ...'), com o erro original em .rejection.
    // Desembrulha para que o HttpErrorResponse de uma promise seja tratado igual ao de um Observable.
    const error: Error | HttpErrorResponse = erroRecebido?.rejection ?? erroRecebido;
    let deveValidar = true;

    if (error instanceof HttpErrorResponse) {
      // Status 0 = requisição nem chegou ao servidor (internet/rede do usuário).
      // Status 504 = requisição chegou, mas o backend demorou demais para responder.
      // Tratados antes do urlsToIgnore para que timeouts nas telas de listagem também exibam a mensagem.
      if (error.status === 0 || error.status === 504) {
        console.error('Global error captured:', error);

        this.ngZone.run(() => {
          this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: 'Erro de conexão',
              mensagem: this.montaMensagemErroConexao(error)
            }
          });
        });

        return;
      }

      const urlsToIgnore: string[] = [
        'conta/contasporperiodo',
        'empresa/visualizatodas',
        'usuario/verificaacessoaomodulo',
        'venda/vendasporperiodo',
        'compra/comprasporperiodo',
        'contaparcela/visualizaparcelasporfiltro',
        'conta/contasporperiodo',
        'caixamovimento/visualizasaldoporfiltro',
        'estoque/visualizaminimo',
        'caixa/visualizaporfiltro',
        'contacontabil/visualizaporfiltro'
      ];

      for (const url of urlsToIgnore) {
        if (error.url?.includes(url)) {
          deveValidar = false;
          break;
        }
      }

      if (deveValidar) {
        console.error('Global error captured:', error);

        // Abra o diálogo dentro da NgZone para garantir detecção de mudanças
        this.ngZone.run(() => {
          this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: 'Erro',
              erro: error
            }
          });
        });
      }
    } else {
      const message = error?.message || '';

      // Evita logar ExpressionChangedAfterItHasBeenCheckedError, que não quebra a aplicação
      if (message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
        return;
      }

      console.error('Non-HTTP error:', error);
    }
  }

  private montaMensagemErroConexao(error: HttpErrorResponse): string {
    if (error.status === 0) {
      if (!navigator.onLine) {
        return 'Sem conexão com a internet. Verifique sua rede e tente novamente.';
      }

      return 'Falha na conexão com o servidor. Verifique sua conexão com a internet e tente novamente. '
        + 'Se a conexão estiver ok e o problema persistir, entre em contato com o suporte.';
    }

    let mensagem = 'O servidor demorou muito para responder.'
    
    if (window.location.href.includes('visualizatodas')) {
      mensagem +=  '\n\nSe você estiver utilizando algum filtro nesta tela, o período filtrado pode estar muito longo, '
        + 'retornando mais de 2 mil registros. Diminua o período filtrado e tente novamente.';
    }else{

      mensagem+= 'Aguarde alguns instantes e tente novamente mais tarde.';
    }

     mensagem += 'Se o problema persistir, entre em contato com o suporte.';


    return mensagem;
  }
}
